module.exports = __webpack_public_path__ + "media/images/close-5cd3645cf868e38fd4b537249c2397f6.svg";